import * as types from '../actions/user-actions';
import Utils from '../utils/utils';
import config from 'config';

const initialState = {
	connectionType: null,
	msisdn: null,
	game: {},
	subscription: {}
};

const userReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.RESET_VALUES:
			return Object.assign({}, state, initialState);
			break;

		case types.GET_USER_SUCCESS:
			if (action.msisdnInHeader === null || action.msisdnInHeader === undefined)
				action.user.connectionType = state.connectionType;
			else
				action.user.connectionType = (action.msisdnInHeader) ? 'HE' : 'WiFi';

			Utils.setLocalStorage(config.constants.userSession, action.user);

			return Object.assign({}, state, action.user, {
				wonNewTicket: action.wonNewTicket
			});
			break;
	}

	return state;
};

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js